import { MaterialInspection } from '../inspection/material-inspection.model';
import { ProjectSectionUnitFormType } from '../project/project-section-unit-form-type.enum';
import { WorkReportAttach } from './work-report-attach.model';

export class InitWorkReportRequest {
  projectId?: number;
  sectionId?: number;
  sectionItemId?: number;
  superviseSectionId?: number;
  menuFormId?: number;
  formId?: number;
  formStarted?: boolean;
  formCompleted?: boolean;
  formSource?: ProjectSectionUnitFormType;
  thirdBusinessIds?: string;
  receiveId?: number;
  fileCountersignSourceId?: number;
  sn?: string;
  formMultipleNo?: number;
  formCodeId?: number;
  formCodeVer?: string;
  formCodeSnId?: number;
  formCodeSn?: number;
  //   workProcedure?: WorkProcedure;
  materialInspections?: Array<MaterialInspection>;
  materialTypeCode?: string;
  userId?: number;
  attachs?: Array<WorkReportAttach>;
  formulaValueMap?: Map<string, string>;
}
